import { Diagram } from 'gojs';

export interface ToggleStatus {
  isFullyCollapsed: boolean;
  isFullyExpanded: boolean;
}

export const getToggleStatus = (diagram: Diagram): ToggleStatus => {
  const groups = diagram.findTopLevelGroups();

  if (!groups.count) {
    return { isFullyCollapsed: false, isFullyExpanded: false };
  }

  let areAllGroupsExpanded = true;
  let areAllGroupsCollapsed = true;

  groups.each(({ isSubGraphExpanded }) => {
    if (isSubGraphExpanded) {
      areAllGroupsCollapsed = false;
    } else {
      areAllGroupsExpanded = false;
    }
  });

  return { isFullyCollapsed: areAllGroupsCollapsed, isFullyExpanded: areAllGroupsExpanded };
};
